import * as React from "react";
import {ThemeProvider} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./src/theme";

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
    if (location.hash) {
        window.setTimeout(() => {
            const el = document.querySelector(location.hash);
            if (el) el.scrollIntoView();
        }, 0);
        return false;
    }
    return [0, 0];
};

export const wrapRootElement = ({element}) => {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {element}
        </ThemeProvider>
    );
};
